import { getJsonSchemaErrorString } from '../../../components/jsonSchemaValidator';
import { getUserError } from '../../../components/miscUtils';
import { generateFilterSchema } from '../actions/steps-definitions/dbActionStepTypeTableJoin';
import { TpChartManifest } from '../charts/interfaces';

function validateChartDef(ChartManifest: TpChartManifest, chartDef: any) {
  const aspectBindingsSchema = {
    type: 'object',
    properties: {} as any,
    required: [] as string[],
    additionalProperties: false,
  };

  for (const aspect of ChartManifest.aspects) {
    aspectBindingsSchema.properties[aspect.id] = {
      anyOf: [
        { type: 'string' },
        {
          type: 'object',
          properties: {
            columnId: { type: 'string' },
          },
          required: ['columnId'],
        },
      ],
    };
    if (aspect.required) aspectBindingsSchema.required.push(aspect.id);
  }

  const configSchema = {
    type: 'object',
    properties: {
      customTitle: { type: 'string' },
      customDescription: { type: 'string' },
    } as any,
    required: [] as string[],
    additionalProperties: true,
  };

  for (const configParam of ChartManifest.configParams) {
    configSchema.properties[configParam.id] = {};
  }

  const schema = {
    type: 'object',
    properties: {
      chartType: { type: 'string' },
      elemType: { type: 'string' },
      id: { type: 'string' },
      selector: { type: 'string' },
      elemLayoutHints: { type: 'object' },
      dataBinding: {
        type: 'object',
        properties: {
          dataTableId: { type: 'string' },
          aspectBindings: aspectBindingsSchema,
        },
        required: ['dataTableId', 'aspectBindings'],
      },
      config: configSchema,
      filter: generateFilterSchema('Optional filter applied to the data shown in the chart.'),
    },
    required: ['chartType', 'dataBinding', 'config'],
    additionalProperties: false,
  };
  const error = getJsonSchemaErrorString(schema, chartDef);
  if (error) {
    throw getUserError(error);
  }
}

export default validateChartDef;
